import { FC } from 'react';

import { Tabs, Tab } from '@mui/material';

import { BonusesTabsEnum } from '../constants';

import { DailyBonusesPageTabsProps } from './types';

import styles from './DailyBonusesPageTabs.module.css';

const { tabsContainer } = styles;

export const DailyBonusesPageTabs: FC<DailyBonusesPageTabsProps> = ({ currentTab, setTab }) => {
  const tabs = Object.values(BonusesTabsEnum);

  return (
    <Tabs className={tabsContainer} textColor="inherit" value={currentTab} variant="scrollable" scrollButtons="auto">
      {tabs.map((tab: BonusesTabsEnum) => {
        const onClick = () => setTab(tab);

        return <Tab onClick={onClick} label={tab} value={tab} key={tab} />;
      })}
    </Tabs>
  );
};
